import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { retry } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';
import { UsersSupportDoc } from 'src/app/shared/models/UsersSupportDoc';
import { UsersSupportWrapperVO } from 'src/app/shared/models/UsersSupportWrapperVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
@Component({
  selector: 'app-users-support',
  templateUrl: './users-support.component.html',
  styleUrls: ['./users-support.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class UsersSupportComponent implements OnInit {


  usersSupportWrapperVO : UsersSupportWrapperVO;
  usersSupportDocList : UsersSupportDoc[];

  selectedUsersSupportDoc: UsersSupportDoc;
  optionDialog:boolean;
  submitted: boolean;
  mailValid : boolean;

  userView:UsersSupportDoc;

  listLanguage : CategoryLan[];
  selectedLanguage: CategoryLan;
  listFunctions : CategoryLan[];
  selectedFunction: CategoryLan;
  listUserTypes : CategoryLan[];
  selectedUserType: CategoryLan;
  responseFile?: ResponseFile;
  blocked:boolean;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) { }

  ngOnInit(): void {
    this.getCategoryByField("language");
    this.getCategoryByField("Function");
    this.getCategoryByField("incUsrTyp");
    this.loadUsersSupport();

  }

  loadUsersSupport(){
    this.apiService.getAllUsersSupport().then(
      responseData => {
        this. usersSupportWrapperVO = responseData;
        const listFilterStore = this.usersSupportWrapperVO.lstUsersSupport.filter( (user) => user.status == "A");
        this.usersSupportDocList = listFilterStore;
    });

  }

  hideDialog() {
    this.optionDialog = false;
    this.submitted = false;
  }

  createUser() {
    this.userView = {};
    this.submitted = false;
    this.optionDialog = true;
  }

  editUser(user: UsersSupportDoc){
    this.userView = {...user};
    this.optionDialog = true;
  }

  getCategoryByField(fieldId: string){
    this.apiService.getCategoryLang({
      "fieldId": fieldId
    }).then(
      data => {
        if(fieldId == "language"){
          this.listLanguage = data
        }else if(fieldId == "Function"){
          this.listFunctions = data;
        }else if(fieldId == "incUsrTyp"){
          this.listUserTypes = data;
        }
    })
  }

  createUserSupport(){
    this.submitted = true;
    // this.mailValid = this.tovpilUtils.isEmailValido(this.userView.email);
    this.mailValid = true;
    

    if(this.userView.userId && this.userView.userName && this.userView.email && this.mailValid){

      this.userView.language = this.selectedLanguage.fieldVal;
      this.userView.function = this.selectedFunction.fieldVal;
      this.userView.type=this.selectedUserType.fieldVal;

      if(this.userView.status && this.userView.type){
        
        this.apiService.updateUserSupport(this.userView).then(
          data => {

            if(data.status === "ERROR"){
              this.messageService.add({severity:'error', summary: 'Actualiza Usuario', detail: data.errorMessage, life: 3000});
              return;
            }

            this.optionDialog = false;
            this.userView = {};
            this.selectedFunction = null;
            this.selectedLanguage = null;
            this.selectedUserType = null;
            this.messageService.add({severity:'success', summary: 'Actualiza Usuario', detail: 'Se creo actualizo usuario soporte correctamente', life: 3000});
            

        })
      }else{
        
        this.userView.status = "A";
        this.userView.type = "A";
        

        this.apiService.createUserSupport(this.userView).then(
          data => {

            if(data.status === "ERROR"){
              this.messageService.add({severity:'error', summary: 'Crear Usuario', detail: data.errorMessage, life: 3000});
              return;
            }

            this.optionDialog = false;
            this.userView = {};
            this.selectedFunction = null;
            this.selectedLanguage = null;
            this.selectedUserType = null;
            this.messageService.add({severity:'success', summary: 'Crear Usuario', detail: 'Se creo usuario soporte correctamente', life: 3000});
            

        })
      }
      this.loadUsersSupport();

      

    }else{
      this.messageService.add({severity:'error', summary: 'Crear Usuario', detail: 'Favor de llenar información requerida', life: 3000});
    }

  }

  deleteUserSupport(user: UsersSupportDoc) {

    this.confirmationService.confirm({
        message: '¿Esta seguro de eliminar al usuario ' + user.userName + ' ?',
        header: 'Confirmar Eliminar',
        icon: 'pi pi-exclamation-triangle',
        acceptButtonStyleClass: "p-button-danger",
        rejectButtonStyleClass: "p-button-info",
        accept: () => {
          this.apiService.deleteUserSupport(user).then(
            user => {
              
              this.messageService.add({severity:'success', summary: 'Eliminar Opción', detail: 'Se elimino opción correctamente', life: 3000});
              this.loadUsersSupport();

          });

        }
    });
  }

  onShowModalOption(){
   
    this.selectedLanguage = this.listLanguage.find( l => l.fieldVal == this.userView.language);
    this.selectedFunction = this.listFunctions.find( l => l.fieldVal == this.userView.function);
    this.selectedUserType = this.listUserTypes.find( l => l.fieldVal == this.userView.type);


  }
  exportExcel(){
    this.blocked = true;
    try {
      

      this.apiService.dwnFIIXls(
        {
          "storeId": "0000000074",
          "year": "2023",
          "sequence": "018",
          "language": "es",
          "userId":"felipepaez",
          "guideId":"0000010",
          "currency":"COP"
        }
      ).then(
        data => {
          this.responseFile = data;

          const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;


          const link = document.createElement("a");
          link.href = source;
          
          link.download = this.responseFile.nameFile
          link.click();
          this.blocked = false;

        })
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: `});
      this.blocked = false;
    }
  }


  exportExcelSFPG(){
    this.blocked = true;
    try {
      this.apiService.dwdSFPGSumaryXLS(
        {
          "storeId": "0000001565",
          "year": "2024",
          "period": "1",
          "language": "en"
        }
      ).then(
        data => {
          this.responseFile = data;
          const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
          const link = document.createElement("a");
          link.href = source;
          
          link.download = this.responseFile.nameFile
          link.click();
          this.blocked = false;
        });
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: `});
      this.blocked = false;
    }
  }

}
